import React from "react";
const SvgExternalLink = props => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#000"
      fillRule="evenodd"
      d="M6.5 5A1.5 1.5 0 005 6.5v11A1.5 1.5 0 006.5 19h11a1.5 1.5 0 001.5-1.5v-3.06a.5.5 0 011 0v3.06a2.5 2.5 0 01-2.5 2.5h-11A2.5 2.5 0 014 17.5v-11A2.5 2.5 0 016.5 4h3.06a.5.5 0 010 1H6.5zm7.41-.5a.5.5 0 01.5-.5h5.09a.5.5 0 01.5.5v5.09a.5.5 0 01-1 0V5.708l-8.116 8.116a.5.5 0 01-.707-.707L18.293 5h-3.884a.5.5 0 01-.5-.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgExternalLink;
